import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import useModalEffect from '../../../hooks/useModalEffect';

const ViewRate = ({ isOpen, onClose, data, unitTypeOptions = [], workflowOptions = [] }) => {
  useModalEffect(isOpen);
  ;

  // Cleanup effect when component unmounts
  useEffect(() => {
    return () => {
      // Clean up any remaining modal states when component unmounts
      const cleanupModal = () => {
        // Remove modal scroll lock
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        document.body.classList.remove('modal-backdrop');
      };
      
      cleanupModal();
    };
  }, []);


  // Cleanup effect: reset modal body state when component unmounts.
  useEffect(() => {
    return () => {
      // React owns the backdrop DOM (createPortal); only reset body state here.
      // Remove modal-open class from body
      document.body.classList.remove('modal-open');
    };
  }, []);

  if (!data) return null;

  const getUnitTypeName = (id) => {
    if (!id) return '';
    const option = unitTypeOptions.find(opt => opt.id.toString() === id.toString());
    return option ? option.name : id;
  };

  // Mapping kode workflow ke nama
  const getWorkflowName = (workflowCode) => {
    if (!workflowCode) return '';
    const option = workflowOptions.find(opt => opt.code === workflowCode || opt.workflowName === workflowCode);
    return option ? option.workflowName : workflowCode;
  };

  return (
    <>
      <div
        className={`modal modal-blur fade${isOpen ? ' show' : ''}`} style={{ display: isOpen ? 'block' : 'none' }}
        id="modal-view-rate"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">View Rate Details</h5>
              <button 
                type="button" 
                className="btn-close" 
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row mb-3">
                <div className="col-4 fw-bold">Services</div>
                <div className="col-8">{data.services}</div>
              </div>
              <div className="row mb-3">
                <div className="col-4 fw-bold">Standard</div>
                <div className="col-8">{data.standard}</div>
              </div>
              <div className="row mb-3">
                <div className="col-4 fw-bold">Product Category</div>
                <div className="col-8">{data.productCategory}</div>
              </div>
              <div className="row mb-3">
                <div className="col-4 fw-bold">Level</div>
                <div className="col-8">{data.level}</div>
              </div>
              <div className="row mb-3">
                <div className="col-4 fw-bold">Service Item</div>
                <div className="col-8">{data.serviceItem}</div>
              </div>
              <div className="row mb-3">
                <div className="col-4 fw-bold">Unit Type</div>
                <div className="col-8">{data.unitTypeName}</div>
              </div>

              <div className="mt-4 mb-3">
                <h4 className="text-muted">Price List Settings</h4>
                <div className="table-responsive">
                  <table className="table table-vcenter card-table">
                    <thead>
                      <tr>
                        <th>Price Range</th>
                        <th>Rate</th>
                        <th>Workflow</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.priceSettings?.map((setting, index) => (
                        <tr key={index}>
                          <td>{setting.rateFrom}</td>
                          <td>{setting.rateTo}</td>
                          <td>{getWorkflowName(setting.workflow)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

ViewRate.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.object,
  unitTypeOptions: PropTypes.array,
  workflowOptions: PropTypes.array
};

export default ViewRate; 